module.exports = __webpack_public_path__ + "img/13.d223ad0e.jpg";